import React from "react";

interface Props {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

export default function ColorPicker(props: Props) {
  return (
    <div className="inline-block relative">
      <div
        className={`flex items-center border p-2 rounded-lg w-32 space-x-2 ${
          props.disabled ? "bg-gray-100 opacity-60 cursor-not-allowed" : ""
        }`}
      >
        <div className="relative h-5 w-5 overflow-hidden border border-slate-300">
          <input
            type="color"
            disabled={props.disabled}
            className="absolute top-[-10px] left-[-10px] h-10 w-10 cursor-pointer disabled:cursor-not-allowed"
            value={props.value}
            onChange={(e) => props.onChange(e.currentTarget.value)}
          />
        </div>
        <input
          type="text"
          disabled={props.disabled}
          value={props.value}
          onChange={(e) => props.onChange(e.currentTarget.value)}
          className="w-full rounded px-1 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400 disabled:bg-gray-100 disabled:cursor-not-allowed"
          maxLength={7}
          placeholder="#FFFFFF"
        />
      </div>
    </div>
  );
}
